<div class="flex-wrapper">
  <div class="application-menu-content">
    <span class="menu-search-span">
      <div soho-searchfield-wrapper>
        <label class="audible" for="{{testVersion1 ? 'banner-searchfield' : 'search-menu-searchfield'}}">{{ 'Search' | translate }}</label>
        <input autofocus #searchField id="{{testVersion1 ? 'banner-searchfield' : 'search-menu-searchfield'}}" soho-toolbar-searchfield
               placeholder="{{ 'Search' | translate }}"
               [(ngModel)]="model.searchFieldValue"
               [collapsibleOnMobile]="true"
               [clearable]="true"
               (ngModelChange)="autoSearchMenu($event)"
               (keydown.enter)="fireMenuSearchEvent($event)"
               (cleared)="fireClearSearchEvent($event)"
        />
      </div>
      <p *ngIf="limitSearch" class="limitedSearch">{{ 'SearchResultLimited' | translate }}</p>
      <p *ngIf="webAppSpecsWithSearchResults.length === 0 && reportSearchResults.length === 0 && dataSearchResults.length === 0" class="noResultFound" >
        {{ 'NoSearchResultsFound' | translate }}
      </p>

      <div class="accordion panel inverse"
          data-options="{'allowOnePane': 'true', 'rerouteOnLinkClick': 'false'}"
          soho-busyindicator blockUI="true" displayDelay="0">

        <!-- SEARCH MENUITEMS RESULTS SECTIONS -->
        <ng-container *ngFor="let webAppSpec of webAppSpecsWithSearchResults">
          <div #searchMenuHeader class="accordion-header" id="ApplicationSearchResults_{{webAppSpec.webAppName}}">
            <svg soho-icon icon="roles"></svg>
            <a href="#" id="{{webAppSpec.webAppName}}SearchResults"><span>{{webAppSpec.webAppTitle}}</span></a>
          </div>

          <div *ngIf="menuSearchResultsByWebApp [ webAppSpec.webAppName ].length > 0" class="accordion-pane">
            <ng-container *ngFor="let menuSearchResult of menuSearchResultsByWebApp [ webAppSpec.webAppName ]">
              <div *ngIf="menuSearchResult.menu" #accordionHeader class="accordion-header">
                <button class="btn" type="button">
                  <span class="icon plus-minus" aria-hidden="true" role="presentation"></span>
                </button>
                <a class="router-link-active"
                    href="#"
                    attr.id="{{menuSearchResult.id}}_searchresult"
                    (click)="onMenuItemClicked(menuSearchResult)"
                >
                  <span class="accordion-search-span-heading">{{menuSearchResult.child}}</span>
                    <ng-container *ngIf="menuSearchResult.parent">
                      <br>
                      <span class="accordion-search-span-subheading">{{menuSearchResult.parent}}</span>
                    </ng-container>
                </a>
              </div>
              <lm-banner-menu *ngIf="menuSearchResult.menu" class="accordion-pane has-icons" [bannerMenuSpec]="menuSearchResult?.menu"></lm-banner-menu>
            </ng-container>

            <ng-container *ngFor="let menuSearchResult of menuSearchResultsByWebApp [ webAppSpec.webAppName ]">
              <div *ngIf="!menuSearchResult.menu" class="accordion-header">
                <a class="router-link-active" href="#"
                    attr.id="{{menuSearchResult.id}}_searchresult"
                    attr.searchMenuUrl="{{menuSearchResult.url}}"
                    (click)="openSearchMenuItem($event)"
                >
                  <span class="accordion-search-span-heading">{{menuSearchResult.child}}</span>
                  <ng-container *ngIf="menuSearchResult.parent">
                    <br>
                    <span class="accordion-search-span-subheading">{{menuSearchResult.parent}}</span>
                  </ng-container>
                </a>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <!-- SEARCH REPORTS RESULTS SECTIONS -->
        <div *ngIf="reportSearchResults.length > 0" #searchMenuHeader class="accordion-header">
          <svg soho-icon icon="bar"></svg>
          <a href="#" id="ReportsSearchResults"><span>{{reportTitle}}</span></a>
        </div>
        <div *ngIf="reportSearchResults.length > 0" class="accordion-pane">
          <ng-container *ngFor="let reportSearchResult of reportSearchResults">
            <div class="accordion-header">
              <a class="router-link-active" href="#"
                  attr.id="Report_{{reportSearchResult.id}}_searchresult"
                  attr.searchMenuUrl="{{reportSearchResult.url}}"
                  (click)="openSearchItemLink($event)"
              >
                <span class="accordion-search-span-heading">{{reportSearchResult.child}}</span><br>
                <span class="accordion-search-span-subheading">{{reportSearchResult.parent}}</span>
              </a>
            </div>
          </ng-container>
        </div>

        <!-- SEARCH DATA RESULTS SECTIONS -->
        <div *ngIf="dataSearchResults.length > 0"  #searchMenuHeader class="accordion-header">
          <svg soho-icon icon="folder"></svg>
          <a href="#" id="DataSearchResults"><span>{{dataTitle}}</span></a>
        </div>
        <div *ngIf="dataSearchResults.length > 0" class="accordion-pane">
          <ng-container *ngFor="let dataSearchResult of dataSearchResults">
            <div class="accordion-header">
              <a class="router-link-active" href="#"
                  attr.id="{{dataSearchResult.id}}_searchresult"
                  attr.resourceId="{{dataSearchResult.resourceId}}"
                  attr.searchMenuUrl="{{dataSearchResult.url}}"
                  (click)="openSearchItemLink($event)"
              >
                <span class="accordion-search-span-heading">{{dataSearchResult.child}}</span><br>
                <span class="accordion-search-span-subheading">{{dataSearchResult.parent}}</span>
              </a>
            </div>
          </ng-container>
        </div>

      </div>
    </span>
  </div>
</div>
<div #menuFormDialog>
  <!-- dialog placeholder used to display action form from menu -->
</div>

<!--Accessibility: ARIA live region-->
<div class="audible" aria-hidden="true" aria-live="polite"> 
  {{ accessibility.announcement }}
</div>
